export default __webpack_public_path__ + "static/media/internet.8735353b.svg";